export const AUDIT_GET = '/api/Audits/get'
export const AUDIT_GET_ALL = '/api/Audits/All'
export const AUDIT_CREATED_BY = '/api/Audits/CreatedBy'



// WEBPACK FOOTER //
// ./src/api/audit/types.js